import React from "react";
import {

	Box,

	Typography,
} from "@mui/material";
import animationData from "./Lotties/loading.json";
import Lottie from "react-lottie";

export default function Loading() {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};

	return (
		<Box
			sx={{
				alignItems: "center",
				justifyContent: "center",
				marginTop: 20,
			}}>
			<Box
				gap='10px'
				display={"flex"}
				alignItems='center'
				flexDirection={"column"}>
				<Box
					component='img'
					src={require("./Logo.png")}
					sx={{
						height: 175,
						width: 175,

						objectFit: "contain",
					}}
				/>

				<Typography variant='h5' fontWeight='500' color='text-primary'>
					Your future is
					<span style={{ color: "#482fd7" }}> Inbound!</span>
				</Typography>

				<Box marginTop={-5}>
					<Lottie options={defaultOptions} height={200} width={200}></Lottie>
				</Box>
			</Box>
		</Box>
	);
}
